import React from "react";
import "./styles.scss";
import RenderItem from "./RenderItem";

export default class ResultComponent extends React.Component {
  state = { items: this.props.items };
  render() {
    const { items = [], label, id, className } = this.props;
    if (!items.length) return null;
    return (
      <div id={id} className={className}>
        <h2 className="label text-uppercase text-default">{label}</h2>
        <div
          className={`result-items d-flex ${
            ["top10-songs", "top10-artists"].includes(id)
              ? ""
              : "justify-content-around"
          }`}
        >
          {items.map((item, i) => (
            <RenderItem key={i} item={item} />
          ))}
        </div>
      </div>
    );
  }
}
